// @flow
import { Button, Col, Form, Input, Modal, Row } from '@duxton-web/ui';
import _ from 'lodash';
import React from 'react';

import MultiSelectDropdown from 'omega-rtc/components/form/ucd/common/MultiSelectDropdown';
import {
  AUDIENCE_TYPES,
  OBJECTIVES_ICON_LABEL,
  PROJECT_ES_FIELDS,
  PROJECT_MORE_FILTERS_KEYS,
} from 'omega-rtc/constants/ucd';
import {
  getArrayInitialValue,
  getStringInitialValue,
} from 'omega-rtc/utils/ucd-utils';

type Props = {
  open: boolean,
  moreFiltersInitialValue: Array,
  updateFilterCount: Function,
  closeFilter: Function,
  onAction: Function,
};

const ProjectMoreFilters = (props: Props) => {
  const [form] = Form.useForm();

  const getCreatedByInitialValue = () => {
    return getStringInitialValue(
      PROJECT_ES_FIELDS.creator,
      props.moreFiltersInitialValue,
    );
  };
  const getAudienceTypesInitialValue = () => {
    return getArrayInitialValue(
      PROJECT_ES_FIELDS.audience,
      props.moreFiltersInitialValue,
    );
  };
  const getGoalInitialValue = () => {
    return getArrayInitialValue(
      PROJECT_ES_FIELDS.objective,
      props.moreFiltersInitialValue,
    );
  };

  const goalOptions = _.map(OBJECTIVES_ICON_LABEL, (val, key) => {
    return { label: val.label, value: key };
  });
  const audienceOptions = _.map(AUDIENCE_TYPES, (__, key) => {
    return { value: key, label: _.toUpper(key) };
  });

  const setDefaultValues = () => {
    form.setFieldsValue({
      [PROJECT_MORE_FILTERS_KEYS.AUDIENCE]: [],
      [PROJECT_MORE_FILTERS_KEYS.OBJECTIVE]: [],
      [PROJECT_MORE_FILTERS_KEYS.CREATOR]: '',
    });
  };
  const onReset = () => {
    props.onAction([], 'reset');
    setDefaultValues();
  };

  const initialValues = {
    audience: getAudienceTypesInitialValue(),
    objective: getGoalInitialValue(),
    creator: getCreatedByInitialValue(),
  };

  const onApply = () => {
    const response = [];
    const values = form.getFieldsValue();

    const audienceTypes = values[PROJECT_MORE_FILTERS_KEYS.AUDIENCE];
    if (audienceTypes && audienceTypes.length > 0) {
      response.push({
        lhs: PROJECT_ES_FIELDS.audience,
        operator: 'in',
        rhs: audienceTypes,
      });
    }

    const objective = values[PROJECT_MORE_FILTERS_KEYS.OBJECTIVE];
    if (objective && objective.length > 0) {
      response.push({
        lhs: PROJECT_ES_FIELDS.objective,
        operator: 'in',
        rhs: objective,
      });
    }

    const createdBy = values[PROJECT_MORE_FILTERS_KEYS.CREATOR];
    if (createdBy && createdBy.length > 0) {
      response.push({
        lhs: PROJECT_ES_FIELDS.creator,
        operator: 'eq',
        rhs: createdBy,
      });
    }

    props.onAction(response, 'apply');
  };

  return (
    <Modal
      open={props.open}
      centered
      width={720}
      title="More filters"
      onCancel={props.closeFilter}
      footer={[
        <Button
          onClick={onReset}
          type="text"
          color="primary"
          style={{ fontWeight: '600' }}
        >
          Reset
        </Button>,
        <Button
          onClick={onApply}
          type="primary"
          style={{ fontWeight: '600', marginLeft: '10px' }}
        >
          Apply
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[20, 0]} style={{ marginTop: 24 }}>
          <Col span={12}>
            <Form.Item
              name={PROJECT_MORE_FILTERS_KEYS.AUDIENCE}
              label="Audience Type"
            >
              <MultiSelectDropdown
                width={'100%'}
                height={'43px'}
                menuWidth={'100%'}
                placeholder="Audience Type"
                initialValue={initialValues.audience}
                options={audienceOptions}
                multiValuePlaceholder={'Multiple Audiences'}
                buttonStyle={{
                  borderRadius: '14px',
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={PROJECT_MORE_FILTERS_KEYS.OBJECTIVE}
              label="Business Objective"
            >
              <MultiSelectDropdown
                width={'100%'}
                height={'43px'}
                menuWidth={'100%'}
                placeholder="Business Objective"
                initialValue={initialValues.objective}
                options={goalOptions}
                multiValuePlaceholder={'Multiple Objectives'}
                buttonStyle={{
                  borderRadius: '14px',
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={PROJECT_MORE_FILTERS_KEYS.CREATOR}
              label="Created By"
            >
              <Input
                placeholder={'Enter Email Address'}
                style={{
                  width: '100%',
                  borderRadius: '14px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ProjectMoreFilters;
